export interface SentryTracing<Span = unknown> {
  getActiveSpan: () => Span | undefined | null;
  spanToTraceHeader: (span: Span) => string;
  spanToBaggageHeader: (span: Span) => string | undefined;
}

export function buildTraceHeaders<Span>(
  tracing: SentryTracing<Span> | null | undefined,
): Record<string, string> {
  if (!tracing) return {};

  const span = tracing.getActiveSpan();
  if (!span) return {};

  const headers: Record<string, string> = {};

  const traceHeader = tracing.spanToTraceHeader(span);
  if (traceHeader) headers["sentry-trace"] = traceHeader;

  const baggage = tracing.spanToBaggageHeader(span);
  if (baggage) headers["baggage"] = baggage;

  return headers;
}
